import useFetch from '@hooks/useFetch';
import { useMemo } from 'react';
import { HOST_TYPE } from '@utils/api-helper/host';

export const getKey = (goalUID, centreUID) => {
  return `api/city-specific-offline-centres/goal/${goalUID}/centre/${centreUID}/`;
};

const useCentreInfo = (goalUID, centreUID) => {
  const centreInfoSWRKey =
    goalUID && centreUID ? getKey(goalUID, centreUID) : null;

  const {
    data: centreInfo,
    mutate: refetchMyInfo,
    ...rest
  } = useFetch(
    centreInfoSWRKey,
    { hostType: HOST_TYPE.CMS },
    { errorRetryCount: 1 }
  );

  const processedCentreInfo = useMemo(() => {
    if (!centreInfo || centreInfo?.error) return null;
    if (centreInfo) return centreInfo;
  }, [centreInfo]);

  return {
    centreInfo: processedCentreInfo,
    refetchMyInfo,
    ...rest,
    key: centreInfoSWRKey
  };
};

export default useCentreInfo;
